import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { 
  Box,
  Typography 
} from '@mui/material';

import YamahaLookback from './YamahaLookback';
import LLUSCBABroker from './LLUSCBABroker';
import DASIAuditRadar from './DASIAuditRadar';
import "./styles.scss";

const HomePage = () => {
  const other = useSelector(state => state.other);

  const [selectedCompany, setSelectedCompany] = useState({});

  useEffect(() => {
    try {
      setSelectedCompany(other.selectedCompany || {});
      console.log(other)
    } catch (err) {}
  }, [other]);

  return (
    <Box>
      {
        (selectedCompany?.Id === "2" || selectedCompany?.Id === "1")
        ?
        // DASIAuditRadar is the full-height split-panel view — no extra header needed
        <DASIAuditRadar />
        :
        <Box>
          <Box sx={{ marginBottom: "40px" }}>
            <Typography variant='h5'>
              {selectedCompany.LegalName || ""}
            </Typography>
          </Box>

          <Box>
            {
              selectedCompany?.Id === "1"
              ?
              <YamahaLookback />
              :
                selectedCompany?.Id === "3"
                ?
                <LLUSCBABroker />
                :
                <></>
            }
          </Box>
        </Box>
      }
    </Box>
  )
}

export default HomePage;